import { render, staticRenderFns } from "./AdminLive.vue?vue&type=template&id=2d018d77&"
import script from "./AdminLive.vue?vue&type=script&lang=js&"
export * from "./AdminLive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports